<script setup lang="ts">
    import { useScheduleCoaching } from '@/js/stores/scheduleCoaching';
    import FilterFormModal from '../../FilterFormModal/FilterFormModal.vue';
    import ScheduleCoachingForm from './ScheduleCoachingForm.vue';
    import ScheduleCoachingPreview from './ScheduleCoachingPreview.vue';
    import { useFilterStoreByName } from '@/js/stores/filter';
    import { FilterStoreName } from '@/js/services/api/filter/types';
    import { createScheduleCoachingRequest } from './scheduleCoaching.utils';
    import { useSuccessDialog } from '@/js/stores/success-dialog';
    import { __ } from '@/js/stores/expressions';
    import {
        useMutatePutScheduleCoachingJob,
        useMutateScheduleCoachingJob,
    } from '@/js/services/api/scheduleCoachingForm/scheduleCoachingFormQueries';

    const scheduleCoachingStore = useScheduleCoaching();
    const filterStore = useFilterStoreByName(FilterStoreName.ScheduleCoachingFilter);

    const { mutateAsync: postCoachingJob } = useMutateScheduleCoachingJob();

    const { mutateAsync: putCoachingJob } = useMutatePutScheduleCoachingJob();

    const successDialogStore = useSuccessDialog();

    const onSubmit = async () => {
        if (scheduleCoachingStore.isValid === false) {
            return;
        }
        if (scheduleCoachingStore.editFormId) {
            await updateJob();
        } else {
            await createJob();
        }
    };

    const updateJob = async () => {
        const request = createScheduleCoachingRequest(
            scheduleCoachingStore.formData,
            filterStore.requestData
        );
        const res = await putCoachingJob({
            coachJobId: scheduleCoachingStore.editFormId as string,
            ...request,
        });

        if (res) {
            scheduleCoachingStore.closeScheduleCoaching();
            successDialogStore.openDialog({
                message: __('schedule-coaching-update-success-title'),
            });
        }
    };

    const createJob = async () => {
        const request = createScheduleCoachingRequest(
            scheduleCoachingStore.formData,
            filterStore.requestData
        );
        const res = await postCoachingJob(request);

        if (res) {
            scheduleCoachingStore.closeScheduleCoaching();
            successDialogStore.openDialog({
                message: __('schedule-coaching-success-title'),
            });
        }
    };
</script>
<template>
    <FilterFormModal
        :show="scheduleCoachingStore.open"
        :loading="false"
        :valid="scheduleCoachingStore.isValid"
        :show-filters="true"
        :filter-store-name="FilterStoreName.ScheduleCoachingFilter"
        :hidden-filters="['dateRange', 'relativeDateRange', 'protocolFormDefinition']"
        @submit="onSubmit"
        @close="scheduleCoachingStore.closeScheduleCoaching"
    >
        <template #form>
            <ScheduleCoachingForm />
        </template>
        <template #preview>
            <ScheduleCoachingPreview :form-id="scheduleCoachingStore.formData.formId" />
        </template>
    </FilterFormModal>
</template>
